import { render, staticRenderFns } from "./Vacancy.vue?vue&type=template&id=3afbe3a0&scoped=true&"
import script from "./Vacancy.vue?vue&type=script&lang=js&"
export * from "./Vacancy.vue?vue&type=script&lang=js&"
import style0 from "./Vacancy.vue?vue&type=style&index=0&id=3afbe3a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afbe3a0",
  null
  
)

export default component.exports